import { Box, Stack, Typography } from "@mui/material";

import type { ActivationPageProps } from "../types";

export function CompanyMemberActivationPage(props: ActivationPageProps) {
  const { passwordField, submitButton, errorMessage } = props;

  return (
    <Box>
      <Typography textAlign="center" variant="h4" fontWeight="bold">
        Activate Your Account
      </Typography>
      <Typography textAlign="center" color="text.secondary" mt={1}>
        Set a password to join your company on Evotrux.
      </Typography>
      <Stack my="2rem" spacing={2}>
        {passwordField}
        {errorMessage}
        {submitButton}
      </Stack>
    </Box>
  );
}
